import { createSlice } from '@reduxjs/toolkit';
import { UiState } from 'constants/ui';
import { stateName } from './constants';
import { transformBanners } from './transformers';
export const initialState = {
  banners: transformBanners({}),
  uiState: UiState.Idle
};

const changeUiState = (draft, action) => {
  const {
    uiState
  } = action.payload;
  draft.uiState = uiState;
};

const fetchBannersSuccess = (draft, action) => {
  const {
    banners
  } = action.payload;
  draft.uiState = UiState.Success;
  draft.banners = banners;
};

const setBanners = (draft, action) => {
  const {
    banners
  } = action.payload;
  draft.banners = banners;
};

const bannersSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    changeUiState,
    fetchBannersSuccess,
    setBanners
  }
});
export const {
  actions
} = bannersSlice;
export const plug = {
  [stateName]: bannersSlice.reducer
};
export default bannersSlice.reducer;